module.exports = {
    GOOGLE : 'Google',
    EXPEDIA: 'Expedia',
  }
  